import JoinMeeting from './JoinMeeting';
export default JoinMeeting;
